import { gql } from 'apollo-angular';

export var sidenav_global_pipelines = gql`
  query navSearchAll {
    pipelineViewFilters(
      hasPipelineViewType: { column: NAME, operator: EQ, value: "Global" }
    ) {
      id
      name
    }
  }
`;
